// Note: not currently being used since we're using the embed, but keeping in case we revert to using the API
class HHNewsletterSignup extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    if (!this.form) return

    this.form.addEventListener('submit', this.submitForm.bind(this))

    this.submitButton = this.querySelector('[type="submit"]')
    this.successBanner = this.querySelector('.js-success-banner')
    this.errorBanner = this.querySelector('.js-error-banner')
  }

  async submitForm(evt) {
    evt.preventDefault()
    this.hideStatus()
    this.submitButton?.setAttribute('disabled', true)

    const formData = new FormData(this.form)
    const email = this.getFormValue(formData, 'email')
    const klaviyoCompanyId = this.getFormValue(formData, 'klaviyo-company-id')
    const klaviyoListId = this.getFormValue(formData, 'klaviyo-list-id')
    const klaviyoGlobalListId = this.getFormValue(formData, 'klaviyo-global-list-id')

    if (!klaviyoCompanyId || !klaviyoListId) {
      this.adminError()
      return
    }

    const shouldSubscribeToGlobalList = !!formData.get('marketing-opt-in')

    const listIds = [klaviyoListId]
    if (shouldSubscribeToGlobalList) {
      if (!klaviyoGlobalListId) {
        this.adminError()
        return
      }

      if (!listIds.includes(klaviyoGlobalListId)) {
        listIds.push(klaviyoGlobalListId)
      }
    }

    await this.createSubscriptions(email, listIds, klaviyoCompanyId)
  }

  getFormValue(formData, name) {
    const value = formData.get(name)
    return typeof value === 'string' ? value.trim() : ''
  }

  async createSubscriptions(email, listIds, klaviyoCompanyId) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoCompanyId}`

    const optionsForList = (listId) => ({
      method: 'POST',
      headers: {
        revision: '2026-01-15',
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }),
    })

    try {
      for (const listId of listIds) {
        const res = await fetch(url, optionsForList(listId))
        if (!res.ok) throw new Error('Klaviyo API error')
      }

      this.form.reset()
      this.form.querySelectorAll('hh-input-wrapper').forEach((inputWrapper) => inputWrapper.removeAttribute('filled'))
      this.form.querySelectorAll('hh-checkbox-wrapper').forEach((checkboxWrapper) => checkboxWrapper.setAttribute('checked', false))

      this.showSuccess()

      setTimeout(() => {
        this.hideStatus()
      }, 5000)
    } catch (error) {
      console.error(error)
      this.showError()
    } finally {
      this.submitButton?.removeAttribute('disabled')
    }
  }

  adminError() {
    console.error(
      'Klaviyo Company ID or List ID not set in theme editor settings'
    )
    this.showError()
    this.submitButton?.removeAttribute('disabled')
  }

  showSuccess() {
    this.successBanner?.removeAttribute('hidden')
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
  }
}

customElements.define('hh-newsletter-signup', HHNewsletterSignup)
